// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2vj8P","ranges":"BmiRanges_ranges__3eJQt"};